module.exports = __webpack_public_path__ + "img/walter-with-duck.5b94635c.jpg";